import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePortalAccess } from '../hooks/usePortalAccess';

/** Route guard for super-admin-only features (e.g. Storage Sync). */
export const SuperAdminGuard: React.FC = () => {
  const { isAdmin, firstPath } = usePortalAccess();

  if (!isAdmin) {
    return <Navigate to={firstPath} replace />;
  }
  return <Outlet />;
};

export default SuperAdminGuard;
